<template>
  <div class="device-detail-fault-main">
    <!-- 搜索排序 -->
    <div class="device-detail-fault-action" v-if="tabLists.length > 0">
      <!-- tab -->
      <ul class="device-detail-tab">
        <li
          v-for="tab in tabLists"
          :key="tab.key"
          :class="activeTabKey === tab.key ? 'active' : ''"
          @click="handleTabs(tab.key)"
        >
          {{ tab.name }}
        </li>
      </ul>

      <!-- 当前故障filter -->
      <div class="device-detail-fault-action-row1" v-if="activeTabKey === '1'">
        <ul class="device-detail-fault-search">
          <li>
            <a-input
              :placeholder="$t('com_form_warning_name_placeholder')"
              v-model="alarmName"
              allowClear
              @pressEnter="getData"
              @change="
                () => {
                  if (!alarmName) {
                    this.getData();
                  }
                }
              "
            />
          </li>
          <li>
            <a-range-picker @change="dateRangeChange" v-model="date" />
          </li>
          <li>
            <a-button type="primary" @click="getData">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button type="default" @click="handleReset">
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
        <div class="device-detail-fault-btn">
          <a-button type="link" @click="handleExpand()">
            <span v-if="!searchExpand">{{ $t('com_btn_expand') }}</span>
            <span v-else>{{ $t('com_btn_collapse') }}</span>
            <a-icon type="up" v-if="searchExpand" />
            <a-icon type="down" v-else />
          </a-button>
        </div>
      </div>
      <!-- 当前故障：展开的搜索 -->
      <div class="device-detail-fault-action-row2" v-if="searchExpand && activeTabKey === '1'">
        <span>{{ $t('com_fault_type') }}</span>
        <a-checkbox-group v-model="faultLevel" @change="getData">
          <a-checkbox value="0">
            OA
          </a-checkbox>
          <a-checkbox value="1">
            MA
          </a-checkbox>
          <a-checkbox value="2">
            CA
          </a-checkbox>
        </a-checkbox-group>
      </div>

      <!-- 历史故障filter -->
      <div class="device-detail-fault-action-row1" v-if="activeTabKey === '2'">
        <ul class="device-detail-fault-search">
          <li>
            <a-input
              :placeholder="$t('com_form_warning_name_placeholder')"
              v-model="alarmNameHistory"
              allowClear
              @pressEnter="getData"
              @change="
                () => {
                  if (!alarmNameHistory) {
                    this.getData();
                  }
                }
              "
            />
          </li>
          <li>
            <a-range-picker @change="dateRangeChangeHistory" v-model="dateHistory" />
          </li>
          <li>
            <a-button type="primary" @click="getData">
              {{ $t('com_btn_lookfor') }}
            </a-button>
            <a-button type="default" @click="handleResetHistory">
              {{ $t('com_btn_reset') }}
            </a-button>
          </li>
        </ul>
        <div class="device-detail-fault-btn">
          <a-button type="link" @click="handleExpandHistory()">
            <span v-if="!searchExpandHistory">{{ $t('com_btn_expand') }}</span>
            <span v-else>{{ $t('com_btn_collapse') }}</span>
            <a-icon type="up" v-if="searchExpandHistory" />
            <a-icon type="down" v-else />
          </a-button>
        </div>
      </div>
      <!-- 历史故障：展开的搜索 -->
      <div
        class="device-detail-fault-action-row2"
        v-if="searchExpandHistory && activeTabKey === '2'"
      >
        <span>{{ $t('com_fault_type') }}</span>
        <a-checkbox-group v-model="faultLevelHistory" @change="getData">
          <a-checkbox value="0">
            OA
          </a-checkbox>
          <a-checkbox value="1">
            MA
          </a-checkbox>
          <a-checkbox value="2">
            CA
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </div>

    <!-- 内容 -->
    <div class="device-detail-fault-content">
      <NoAuth v-if="!(AUTH_DEVICE_FAULT_CURRENT || AUTH_DEVICE_FAULT_HISTORY)" />

      <div v-if="activeTabKey === '1' && AUTH_DEVICE_FAULT_CURRENT" class="g-table">
        <a-table
          :columns="currentColumns"
          :data-source="currentDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleCurrentTable"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text">
            <a-popover
              :title="text"
              trigger="click"
              v-if="text && getFaultContent(text) && AUTH_DOCS_DETAIL_TYPE"
            >
              <template slot="content">
                <div
                  class="g-html-content"
                  style="all:inherit !important;max-height: 300px !important;
                  overflow:  auto !important;"
                  v-html="getFaultContent(text)"
                />
              </template>
              <span class="fault-title">{{ text }}</span>
            </a-popover>

            <span v-else>
              {{ text }}
            </span>
          </template>
          <!-- 时间 -->
          <template slot="startTime" slot-scope="text">
            <span v-if="text">
              {{ text | formatDate('yyyy-MM-dd HH:mm:ss', true) }}
            </span>
            <span v-else>
              --
            </span>
          </template>

          <template slot="endTime" slot-scope="text">
            <span v-if="text">
              {{ text | formatDate('yyyy-MM-dd HH:mm:ss', true) }}
            </span>
            <span v-else>
              --
            </span>
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="currentPagination.current"
            :total="currentPagination.total"
            :pageSize.sync="currentPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>

      <div v-if="activeTabKey === '2' && AUTH_DEVICE_FAULT_HISTORY" class="g-table">
        <a-table
          :columns="historyColumns"
          :data-source="historyDataList"
          :rowKey="(text, index) => text.id"
          bordered
          :pagination="false"
          @change="handleHistoryTable"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text">
            <a-popover
              :title="text"
              trigger="click"
              v-if="text && getFaultContent(text) && AUTH_DOCS_DETAIL"
            >
              <template slot="content">
                <div
                  class="g-html-content"
                  style="all:inherit !important;max-height: 300px !important;
                  overflow:  auto !important;"
                  v-html="getFaultContent(text)"
                />
              </template>
              <span class="fault-title">{{ text }}</span>
            </a-popover>

            <span v-else>
              {{ text }}
            </span>
          </template>

          <!-- 时间 -->
          <template slot="startTime" slot-scope="text">
            <span v-if="text">
              {{ text | formatDate('yyyy-MM-dd HH:mm:ss', true) }}
            </span>
            <span v-else>
              --
            </span>
          </template>

          <template slot="endTime" slot-scope="text">
            <span v-if="text">
              {{ text | formatDate('yyyy-MM-dd HH:mm:ss', true) }}
            </span>
            <span v-else>
              --
            </span>
          </template>
        </a-table>
        <div class="pagination" style="margin-bottom:20px;">
          <Pagination
            :current.sync="historyPagination.current"
            :total="historyPagination.total"
            :pageSize.sync="historyPagination.pageSize"
            :callback="currentPageChange"
            @change="currentPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { DeviceCurrentFault, DeviceHistoryFault } from '@/api/device';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { getDocumentDetailByType } from '@/api/docs';
import { parseHtmlContentToObject, trimAllSpace } from '@/libs/utils';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { trim } from '@/libs/utils';

export default {
  mixins: [deviceAuth, docsAuth],
  props: {
    // 设备id
    deviceId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  data() {
    return {
      trim,
      // 当前tab
      activeTabKey: '1',
      tabLists: [],

      // 展开
      searchExpand: true,
      searchExpandHistory: true,

      // 当前数据
      currentDataList: null,

      // 历史数据
      historyDataList: null,

      // 列表
      currentColumns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => {
            if (this.activeTabKey === '1') {
              return `${index +
                1 +
                (this.currentPagination.current - 1) * this.currentPagination.pageSize}`;
            } else {
              return `${index +
                1 +
                (this.historyPagination.current - 1) * this.historyPagination.pageSize}`;
            }
          },
          align: 'center',
          width: 60,
        },

        {
          title: this.$t('com_table_warning_level'),
          dataIndex: 'lev',
          customRender: text => {
            const _text = Number(text);
            return _text === 0 ? 'OA' : _text === 1 ? 'MA' : _text === 2 ? 'CA' : '--';
          },
        },

        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('com_table_code'),
          dataIndex: 'code',
          customRender: text => {
            return text || '--';
          },
        },

        {
          title: this.$t('com_table_souce'),
          dataIndex: 'src',
        },

        {
          title: this.$t('logs_table_time_start'),
          dataIndex: 'startTm',
          scopedSlots: { customRender: 'startTime' },
          sorter: true,
        },
      ],

      // 列表
      historyColumns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => {
            if (this.activeTabKey === '1') {
              return `${index +
                1 +
                (this.currentPagination.current - 1) * this.currentPagination.pageSize}`;
            } else {
              return `${index +
                1 +
                (this.historyPagination.current - 1) * this.historyPagination.pageSize}`;
            }
          },
          align: 'center',
          width: 60,
        },

        {
          title: this.$t('com_table_warning_level'),
          dataIndex: 'lev',
          customRender: text => {
            const _text = Number(text);
            return _text === 0 ? 'OA' : _text === 1 ? 'MA' : _text === 2 ? 'CA' : '--';
          },
        },

        {
          title: this.$t('com_table_name'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('com_table_code'),
          dataIndex: 'code',
          customRender: text => {
            return text || '--';
          },
        },

        {
          title: this.$t('com_table_souce'),
          dataIndex: 'src',
        },

        {
          title: this.$t('logs_table_time_start'),
          dataIndex: 'startTm',
          scopedSlots: { customRender: 'startTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_time_end'),
          dataIndex: 'endTm',
          scopedSlots: { customRender: 'endTime' },
          sorter: true,
        },
      ],

      date: [],
      deviceName: '',
      alarmName: '',
      faultCode: '',
      faultLevel: ['0', '1', '2'],

      dateHistory: [],
      deviceNameHistory: '',
      alarmNameHistory: '',
      faultCodeHistory: '',
      faultLevelHistory: ['0', '1', '2'],

      currentPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序
        orderType: 1,
        orderField: 2,
      },

      historyPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,

        // 排序
        orderType: 1,
        orderField: 2,
      },

      // 故障告警内容
      faultHtmlContent: '',
      faultHtmlContentObject: null,
    };
  },
  created() {
    // tabs - 当前故障
    if (this.AUTH_DEVICE_FAULT_CURRENT) {
      this.tabLists.push({
        key: '1',
        name: this.$t('com_fault_current'),
      });
    }

    // tabs - 历史故障
    if (this.AUTH_DEVICE_FAULT_HISTORY) {
      this.tabLists.push({
        key: '2',
        name: this.$t('com_fault_history'),
      });
    }

    // 当前定位到第一个tab
    if (this.tabLists.length > 0) {
      this.activeTabKey = this.tabLists[0].key;
    }

    this.getData();

    // 判断是否有权限查看
    if (this.AUTH_DOCS_DETAIL_TYPE) {
      this.getFaultHtmlContent();
    }
  },
  methods: {
    // 获取故障告警
    getFaultHtmlContent() {
      // 20250222:文档编号,必填; 100 表示设备告警信息（alarm）文档，101 表示设备配置信息文档，102 表示设备运行信息文档；其他：待定
      getDocumentDetailByType({ type: 100 }).then(res => {
        if (res.code === 0) {
          this.faultHtmlContent = res.data?.content || '';
          this.faultHtmlContentObject = parseHtmlContentToObject(this.faultHtmlContent, 'h1');
        }
      });
    },

    // 匹配当前页面的错误
    getFaultContent(name) {
      if (this.faultHtmlContentObject) {
        // 去掉name的前后及中间空格
        const _name = trimAllSpace(name);
        return this.faultHtmlContentObject[_name] || '';
      }
      return '';
    },

    handleTabs(key) {
      this.activeTabKey = key;
      this.getData();
    },

    // 日期范围改变
    dateRangeChange(value) {
      this.date = value;

      // 重新获取数据
      this.getData();
    },

    // 日期范围改变
    dateRangeChangeHistory(value) {
      this.dateHistory = value;

      // 重新获取数据
      this.getData();
    },

    // 获取数据
    getData() {
      if (this.activeTabKey === '1') {
        this.getCurrentFaultList();
      } else {
        this.getHistoryFaultList();
      }
    },

    // 获取当前故障
    getCurrentFaultList(_params = {}) {
      // devId:"设备ID，必填",
      // levels:"告警等级，如果全部则不传，如果多个值则英文逗号区分，其值对应设备告警等级。0:OA,1:MA;2:CA",
      // keyword:"查询关键字",
      // startTime:"开始时间，必填, long类型",
      // endTime:"结束时间，必填, long类型",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const params = {
        devId: this.deviceId,
        pageNo: this.currentPagination.current,
        pageSize: this.currentPagination.pageSize,
        levels: this.faultLevel ? this.faultLevel.join(',') : '',
        keyword: this.trim(this.alarmName) || undefined,
        // faultCode: this.faultCode,
        orderType: this.currentPagination.orderType,
        orderField: this.currentPagination.orderField,
        ...(_params || {}),
      };
      if (this.date && this.date.length > 0) {
        params.startTime = this.date[0].startOf('day').valueOf();
      }
      if (this.date && this.date.length > 0) {
        params.endTime = this.date[1].endOf('day').valueOf();
      }

      DeviceCurrentFault(params).then(res => {
        if (res.code === 0) {
          this.currentDataList = res.data || [];

          this.currentPagination.total = res.totalCount || 0;
        }
      });
    },

    // 获取历史故障
    getHistoryFaultList(_params = {}) {
      // devId:"设备ID，必填",
      // levels:"告警等级，如果全部则不传，如果多个值则英文逗号区分，其值对应设备告警等级。0:OA,1:MA;2:CA",
      // keyword:"设备名",
      // startTime:"开始时间，必填, long类型",
      // endTime:"结束时间，必填, long类型",
      // pageNo:"页码",
      // pageSize:"每页数量",

      const params = {
        devId: this.deviceId,
        pageNo: this.historyPagination.current,
        pageSize: this.historyPagination.pageSize,
        levels: this.faultLevelHistory ? this.faultLevelHistory.join(',') : '',
        keyword: this.trim(this.alarmNameHistory) || undefined,
        // faultCode: this.faultCode,
        orderType: this.historyPagination.orderType,
        orderField: this.historyPagination.orderField,
        ...(_params || {}),
      };

      if (this.dateHistory && this.dateHistory.length > 0) {
        params.startTime = this.dateHistory[0].startOf('day').valueOf();
      }
      if (this.dateHistory && this.dateHistory.length > 0) {
        params.endTime = this.dateHistory[1].endOf('day').valueOf();
      }

      DeviceHistoryFault(params).then(res => {
        if (res.code === 0) {
          this.historyDataList = res.data || [];

          this.historyPagination.total = res.totalCount || 0;
        }
      });
    },

    // reset
    handleReset() {
      this.date = null;
      // this.deviceName = '';
      this.alarmName = '';
      // this.faultCode = '';
      this.faultLevel = [];
      this.currentPagination.current = 1;

      // 重新获取数据
      this.getData();
    },

    // reset
    handleResetHistory() {
      this.dateHistory = null;
      // this.deviceName = '';
      this.alarmNameHistory = '';
      // this.faultCode = '';
      this.faultLevelHistory = [];
      this.historyPagination.current = 1;

      // 重新获取数据
      this.getData();
    },

    // 展开
    handleExpand() {
      this.searchExpand = !this.searchExpand;
    },

    handleExpandHistory() {
      this.searchExpandHistory = !this.searchExpandHistory;
    },

    // 分页
    currentPageChange(page) {
      if (this.activeTabKey === '1') {
        this.currentPagination.current = page;
      } else {
        this.historyPagination.current = page;
      }

      // 重新获取数据
      this.getData();
    },

    // 排序
    handleCurrentTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'startTm') {
        orderField = 1;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.currentPagination.orderField = orderField;
      this.currentPagination.orderType = orderType;

      this.getCurrentFaultList({
        orderField,
        orderType,
      });
    },

    // 排序
    handleHistoryTable(pagination, filters, sorter) {
      const { field, order } = sorter;
      let orderField = 3;
      let orderType = 1;
      console.log('field', field);

      if (field === 'startTm') {
        orderField = 1;
      } else if (field === 'endTm') {
        orderField = 2;
      }
      orderType = order === 'ascend' ? 0 : 1;

      this.historyPagination.orderField = orderField;
      this.historyPagination.orderType = orderType;

      this.getHistoryFaultList({
        orderField,
        orderType,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.device-detail-fault-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: @g-layout-background;

  // 搜索
  .device-detail-fault-action {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    margin-bottom: 16px;

    .device-detail-tab {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
      gap: 24px;
      margin-bottom: 16px;
      li {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        display: flex;

        &.active {
          color: @primary-color;
          font-weight: 600;
          position: relative;

          &::after {
            content: '';
            display: block;
            width: 100%;
            height: 2px;
            background: @primary-color;
            position: absolute;
            bottom: -4px;
            left: 0;
          }
        }
      }
    }

    .device-detail-fault-action-row1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      // 搜索排序
      ul.device-detail-fault-search {
        display: flex;
        margin: 0;
        padding: 0;
        list-style: none;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        li {
          display: flex;
          align-items: center;
          width: 296px;
          gap: 12px;
          &:last-child {
            width: auto;
          }
        }
      }

      // 排序
      .device-detail-fault-btn {
        display: flex;
        align-items: center;
        height: 40px;

        button {
          margin-left: 12px;
        }
      }
    }

    .device-detail-fault-action-row2 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 24px 0 0 0;
      span {
        color: rgba(0, 0, 0, 0.88);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        margin-right: 16px;
      }
    }
  }

  // 内容
  .device-detail-fault-content {
    background: #fff;
    box-shadow: 0 -12px 0 0 @g-layout-background;
    border-radius: 12px 12px 0 0;
    flex: 1;
    padding: 24px;

    .fault-title {
      color: @primary-color;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    // 卡片模式
    .device-detail-fault-content-card {
      display: flex;
      grid-gap: 16px;
      padding-top: 16px;
      width: 100%;
      flex-wrap: wrap;

      li {
        width: calc(20% - 16px);
        height: 337px;
        border-radius: 6px;
        border: 1px solid #eee;

        .card-title {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 8px;
          padding: 24px 24px 0 24px;

          a {
            color: rgba(0, 0, 0, 0.88);
            text-decoration: none;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: block;
            width: 100%;

            &:hover {
              color: @primary-color;
            }
          }
        }

        .card-content {
          padding: 0 24px 16px 24px;
          .card-content-time {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin: 0;

            dd {
              color: rgba(0, 0, 0, 0.45);
              font-size: 14px;
              height: 80px;
              width: 50%;
              border-radius: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              strong {
                font-size: 36px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
              }
              span {
                color: #18181a;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
              }

              &:first-child {
                background: #f6ffed;
                strong {
                  color: #52c41a;
                }
              }

              &:last-child {
                background: #fffbe6;
                strong {
                  color: #faad14;
                }
              }
            }
          }
          p {
            padding: 0;
            margin: 0 0 8px 0;
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            label {
              white-space: nowrap;
            }

            span {
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }

        .card-action {
          padding: 8px 0;
          border-top: #eee solid 1px;
          dl {
            display: flex;
            justify-content: space-between;

            dd {
              cursor: pointer;
              font-size: 16px;
              transition: all 0.3s;
              border-right: solid 1px rgba(0, 0, 0, 0.06);
              flex: 1;
              height: 38px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:last-child {
                border-right: none;
              }

              a {
                display: flex;
                width: 100%;
                align-items: center;
                justify-content: center;
                color: #000;
                cursor: pointer;
                height: 100%;

                svg {
                  width: 24px;
                  height: 24px;
                  opacity: 0.45;
                }

                &:hover {
                  color: @primary-color;
                  svg.icon {
                    color: @primary-color;
                  }
                }
              }
            }
          }
        }

        &:hover {
          box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }

    // 列表模式
    .device-detail-fault-content-list {
      padding-top: 16px;

      .device-detail-fault-action {
        display: flex;
        background: none;
        padding: 0;
        margin: 0;
        height: auto;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
